var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgJava = function SvgJava(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.074 12.66C33.956 4.99 28.884 0 28.884 0c.755 7.931-8.165 9.804-10.556 15.254-1.632 3.719 1.117 6.975 5.743 11.08-.41-.91-1.04-1.793-1.679-2.687-2.177-3.05-4.446-6.227 1.682-10.986Z",
    fill: "#E76F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.651 28.015s2.974-2.398.62-5.064c-7.982-9.043 8.728-13.147 8.728-13.147-10.202 4.915-8.679 7.832-6.115 11.376 2.746 3.8-3.233 6.835-3.233 6.835Z",
    fill: "#E76F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.406 35.168c9.157-4.68 4.923-9.176 1.968-8.57-.725.148-1.048.276-1.048.276s.27-.414.783-.593c5.847-2.022 10.343 5.961-1.888 9.123 0 0 .142-.124.185-.236ZM15.35 29.245c-5.73-.752 3.141-2.824 3.141-2.824s-3.445-.229-7.682 1.785c-5.01 2.384 12.393 3.468 21.402 1.138.937-.63 2.231-1.174 2.231-1.174s-3.686.647-7.358.952c-4.492.37-9.315.442-11.734.123ZM17.53 33.714c-3.196-.325-1.104-1.848-1.104-1.848-8.268 2.698 4.6 5.758 16.154 2.436-1.228-.425-2.01-1.204-2.01-1.204-5.646 1.07-8.909 1.035-13.04.616ZM18.922 38.549c-3.193-.361-1.328-1.428-1.328-1.428-7.505 2.062 4.565 6.323 14.12 2.296-1.564-.599-2.685-1.29-2.685-1.29-4.262.793-6.24.856-10.107.422Z",
    fill: "#5382A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.908 41.008s1.38 1.119-1.52 1.984c-5.516 1.643-22.957 2.14-27.802.065-1.741-.745 1.525-1.779 2.552-1.996 1.072-.228 1.684-.186 1.684-.186-1.937-1.341-12.52 2.635-5.375 3.774 19.482 3.107 35.515-1.4 30.461-3.64Z",
    fill: "#5382A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43.452c-.32 4.09-13.818 4.95-22.609 4.397-5.734-.362-6.884-1.265-6.9-1.278 5.488.89 14.741 1.051 22.244-.337C41.385 45.002 42 43.452 42 43.452Z",
    fill: "#5382A1"
  })));
};

export default SvgJava;